<template>
  <div>
    <div class="card">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Controls -->
          <!-- Page Controls End -->
          <div class="table-container">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">
                    <div class="d-flex align-items-center">Name</div>
                  </th>
                  <th scope="col">Email</th>
                  <th scope="col">Employer</th>
                  <th scope="col" style="width: 140px;">Account type</th>
                  <th scope="col">Subject</th>
                  <th scope="col">Job</th>
                  <th scope="col" style="width: 140px;">Created date</th>
                  <th scope="col" style="width: 140px;">Trigger date</th>
                  <th scope="col" style="width: 155px;">Completed date</th>
                </tr>
              </thead>
              <tbody>
                <!--  <tr v-for="source in filteredSourceList" :key="source.id"> -->
                <tr v-for="(email, index) in emails" :key="index">
                  <td v-if="email.user_for_employer_name !== null || email.candidate_name !== null">
                    {{
                      email.account_type === 1 ? email.user_for_employer_name : email.candidate_name
                    }}
                  </td>
                  <td v-else></td>
                  <td>
                    <a :href="`mailto:${email.email}`">
                      {{ email.email }}
                    </a>
                  </td>
                  <td>
                    {{
                      email.employer_name !== null
                        ? `${email.employer_name}, ${email.city_for_employer}`
                        : ''
                    }}
                  </td>
                  <td>{{ email.account_type === 1 ? 'Employer' : 'Candidate' }}</td>
                  <td>{{ email.type }}</td>
                  <td>{{ email.job_title }}{{ email.job_city ? `, ${email.job_city}` : '' }}</td>
                  <td>
                    {{
                      email.created_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: true,
                        })
                    }}
                  </td>
                  <td>
                    {{
                      email.trigger_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: true,
                        })
                    }}
                  </td>
                  <td>
                    {{
                      email.completed_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: true,
                        })
                    }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="d-flex" style="    justify-content: end;">
              <Pagination
                :currentPage="currentPage"
                :totalPages="totalPages"
                @nextPage="nextPage"
                @prevPage="previousPage"
                @keyup="keymonitor"
                @selectPageByNumber="setPageBynumber"
                @firstPage="setToFirstPage"
                @lastPage="setToLastPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import titleMixin from '../../mixins/titleMixin';
import Pagination from '../Navigations/Pagination.vue';

export default {
  mixins: [titleMixin],
  title() {
    return 'Engagement | Jobshark';
  },
  /*   description() {
    return 'Page description goes here.';
  }, */
  canonicalLink() {
    return 'https://jobshark.eu/admin/engagement';
  },
  components: {
    Pagination,
  },
  data: () => ({
    isLoading: false,
    searchWord: '',
    campaigns: [],

    editCampaignUUID: '',
    editCampaignId: '',
    editCampaignMedium: '',
    editCampaignCampaign: '',
    editCampaignBudget: '',
    editCampaignStartDate: '',

    emails: [],
    currentPage: 1,
    totalPages: 1,
  }),
  methods: {
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.totalPages) {
        // this.isLoading = true;
        this.currentPage++;
        this.getCampaigns();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        --this.currentPage;
        this.getCampaigns();
      }
    },

    setPageBynumber(number) {
      if (number > this.totalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;
    },
    setToFirstPage() {
      this.currentPage = 1;
    },
    setToLastPage() {
      this.currentPage = this.totalPages;
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    getCampaigns() {
      axios(`${process.env.VUE_APP_API_URL}/admin/engagement/list`, {
        method: 'post',
        data: {
          page: this.currentPage,
          count: 10,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.emails = res.data.data;
        this.totalPages = res.data.last_page;
      });
    },

    addCampaign() {
      axios(`${process.env.VUE_APP_API_URL}/admin/campaign/create`, {
        method: 'post',
        data: {
          campaign_id: this.editCampaignId,
          campaign_medium: this.editCampaignMedium,
          campaign_name: this.editCampaignCampaign,
          campaign_budget: this.editCampaignBudget,
          campaign_start_date: this.editCampaignStartDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.resetModal();
          this.getCampaigns();
          this.$refs.closeAdd.click();
          this.$toasted.success('New campaign created', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(() => {
          this.$toasted.error('There was error while trying to add new campaign', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    updateCampaign() {
      axios(`${process.env.VUE_APP_API_URL}/admin/campaign/update`, {
        method: 'post',
        data: {
          id: this.editCampaignUUID,
          campaign_medium: this.editCampaignMedium,
          campaign_name: this.editCampaignCampaign,
          campaign_budget: this.editCampaignBudget,
          campaign_start_date: this.editCampaignStartDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.getCampaigns();
          this.$refs.closeEdit.click();
          this.$toasted.success('Saved.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(() => {
          this.$toasted.error('There was error while trying to edit campaign.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    deleteCampaign() {
      axios
        .delete(`${process.env.VUE_APP_API_URL}/admin/campaign/delete/${this.editCampaignUUID}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(() => {
          this.resetModal();
          this.getCampaigns();
          this.$refs.closeDelete.click();
          this.$toasted.success('Campaign Deleted.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(() => {
          this.$toasted.error('There was error while trying to delete campaign.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    handleEditClick(campaign) {
      this.setForEdit(campaign);
      this.$nextTick(() => {
        // Ensure the data is set before showing the modal
        let editModal = new bootstrap.Modal(document.getElementById('editCampaignModal'));
        editModal.show();
      });
    },

    handleDeleteClick(campaign) {
      this.setForEdit(campaign);
      this.$nextTick(() => {
        // Ensure the data is set before showing the modal
        let deleteModal = new bootstrap.Modal(document.getElementById('deleteCampaignModal'));
        deleteModal.show();
      });
    },

    setForEdit(data, status) {
      this.editCampaignUUID = data.id;
      this.editCampaignId = data.campaign_id;
      this.editCampaignMedium = data.medium;
      this.editCampaignCampaign = data.campaign;
      this.editCampaignBudget = data.budget;
      this.editCampaignStartDate = data.start_date;
    },
    resetModal() {
      this.editCampaignUUID = '';
      this.editCampaignId = '';
      this.editCampaignMedium = '';
      this.editCampaignCampaign = '';
      this.editCampaignBudget = '';
      this.editCampaignStartDate = '';
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.getCampaigns();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;
  .input-group {
    width: 35%;
    position: relative;
    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 4px !important;
    }
  }
  .btn-outline-success {
    border-color: #ced4da;
  }
}
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 42px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;
      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }
      .btn-success {
        font-size: 13px;
      }
    }
    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;
        span {
          float: right;
        }
      }
    }
  }
}
.table-container {
  padding: 1rem;
  .table {
    a {
      text-decoration: none;
    }
    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      th {
        vertical-align: middle;
        i {
          font-size: 31px;
          margin-right: 12px;
        }
        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }
        &:last-of-type {
          a {
            margin-left: 12px;
            color: #666;
            i {
              font-size: 16px;
            }
          }
        }
        .is-open {
          .fas {
            -ms-transform: rotate(90deg); /* IE 9 */
            transform: rotate(90deg); /* Standard syntax */
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;
          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }
        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;
          &:last-of-type {
            padding-right: 23px;
            a {
              color: #666;
              margin-left: 28px;
              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg); /* Standard syntax */
}
</style>
